export const FrCauses = [
  {
    label: 'Medical Treatment',
    value: 'medical'
  },
  {
    label: 'NGO / Charity',
    value: 'ngo'
  },
  {
    label: 'Other Cause',
    value: 'other'
  },
];

export const FrCausesVernacular = [
  {
    label: {
      English: 'Medical Treatment',
      Hindi: 'चिकित्सा उपचार',
      Telugu: ' వైద్య చికిత్స',
      Tamil: 'மருத்துவ சிகிச்சை',


    },
    value: 'medical'
  },
  {
    label: {
      English: 'NGO / Charity',
      Hindi: 'एन.जी.ओ / चैरिटी',
      Telugu: 'ఎన్జీఓ / దాతృత్వం',
      Tamil: 'என்ஜிஓ / தொண்டு',


    },
    value: 'ngo'
  },
  {
    label: {
      English: 'Other Cause',
      Hindi: 'अन्य कारण',
      Telugu: 'ఇతర కారణాలు',
      Tamil: 'பிற காரணங்கள்',

    },
    value: 'other'
  },
];